import { Button, Icon, Input, Progress, Divider } from 'semantic-ui-react';
import SusuToggle from '../common/SusuToggle';

const ClothingSelectedControls = ({
    preview,
    clothesName,
    editingName,
    tempName,
    setTempName,
    onSaveName,
    onStartEditName,
    onOpenEditor,
    onRemoveBackgroundClick,
    onToggleBackground,
    onDeleteClick,
    onSubmit,
    isOperationInProgress,
    hasCredits,
    creditBalance,
    daysUntilReset,
    isEditMode,
    hasRemovedBg,
    useRemovedImage,
    uploadProgress,
    isPublic,
    setIsPublic,
    hasChanges = true // Default to true so Save is enabled when prop not provided
}) => {
    // Only show controls in edit mode - new uploads auto-close after upload
    if (!isEditMode) {
        return (
            <div className="selected-clothing-controls">
                {/* Progress indicator for new uploads */}
                {isOperationInProgress && uploadProgress > 0 && (
                    <Progress
                        percent={uploadProgress}
                        color="teal"
                        progress
                        indicating
                    />
                )}

                {/* Preview Image for visual feedback during upload */}
                {preview && (
                    <div className="clothing-preview-container">
                        <img
                            src={preview}
                            alt="Preview"
                            className="clothing-preview"
                        />
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className="selected-clothing-controls">
            {/* Action Buttons - Single row */}
            <div className="action-buttons-row" style={{
                display: 'flex',
                gap: '8px',
                marginBottom: '12px'
            }}>
                <Button
                    color="teal"
                    onClick={onSubmit}
                    disabled={!preview || isOperationInProgress || !hasChanges}
                    style={{
                        flex: 2,
                        margin: 0,
                        padding: '10px 8px',
                        fontSize: '12px'
                    }}
                >
                    <Icon name="save" />
                    Save
                </Button>

                <Button
                    basic
                    color="teal"
                    onClick={onOpenEditor}
                    disabled={!preview || isOperationInProgress}
                    style={{
                        flex: 1,
                        margin: 0,
                        padding: '10px 8px',
                        fontSize: '12px'
                    }}
                >
                    <Icon name="crop" />
                    Crop
                </Button>

                <Button
                    color="red"
                    basic
                    onClick={onDeleteClick}
                    disabled={isOperationInProgress}
                    style={{
                        flex: 1,
                        margin: 0,
                        padding: '10px 8px',
                        fontSize: '12px'
                    }}
                >
                    <Icon name="trash" />
                    Delete
                </Button>
            </div>

            {/* Progress indicator */}
            {isOperationInProgress && uploadProgress > 0 && (
                <Progress
                    percent={uploadProgress}
                    color="teal"
                    progress
                    indicating
                    style={{ marginBottom: '12px' }}
                />
            )}

            {/* Name Input Section */}
            <div className="name-input-section">
                {editingName ? (
                    <Input
                        fluid
                        value={tempName}
                        onChange={(e) => setTempName(e.target.value)}
                        onBlur={onSaveName}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                onSaveName();
                            }
                        }}
                        placeholder="Enter name"
                        autoFocus
                        disabled={isOperationInProgress}
                        size="small"
                    />
                ) : (
                    <div
                        className="display-name-section"
                        onClick={onStartEditName}
                        style={{
                            padding: '10px 14px',
                            fontSize: '13px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px'
                        }}
                    >
                        <Icon name="pencil" size="small" style={{ opacity: 0.5, margin: 0 }} />
                        <span className="display-name" style={{ color: '#888' }}>
                            {clothesName || 'Click to add name'}
                        </span>
                    </div>
                )}
            </div>

            {/* Share to Community Toggle */}
            <div style={{ padding: '12px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke={isPublic ? '#00b5ad' : '#999'}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{ flexShrink: 0 }}
                    >
                        <circle cx="12" cy="12" r="10" />
                        <line x1="2" y1="12" x2="22" y2="12" />
                        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                    </svg>
                    <span style={{ fontSize: '13px', color: '#333', fontWeight: 500, lineHeight: '16px' }}>Share to Community</span>
                </div>
                <SusuToggle
                    checked={isPublic}
                    onChange={(checked) => setIsPublic(checked)}
                    disabled={isOperationInProgress}
                />
            </div>

            <Divider style={{ margin: '0 0 0 0' }} />

            {/* Preview Image */}
            <div
                className="clothing-preview-container"
                onClick={() => document.getElementById('clothing-file-input')?.click()}
                style={{ cursor: 'pointer', position: 'relative' }}
            >
                {preview ? (
                    <>
                        <img
                            src={preview}
                            alt="Preview"
                            className="clothing-preview"
                        />
                    </>
                ) : (
                    <div className="clothing-placeholder">
                        <Icon name="image outline" size="huge" color="grey" />
                        <p>Click to upload image</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ClothingSelectedControls;
